import { faIcon } from "@utils/faIcon"

import { Badge } from "@atoms"

import { GenerationModeBadgeProps } from "./GenerationModeBadge.types"

const icon = faIcon({ name: "layer-group", style: "regular" })

export default function GenerationModeBadge(props: GenerationModeBadgeProps) {
    const { mode, size = "md" } = props

    return (
        <Badge size={size} variant="icon" icon={icon}>
            {mode}
        </Badge>
    )
}
